<template>
  <div v-if="false"></div>
</template>

<script>
import ClusterSource from "ol/source/Cluster";

import GeoJSON from "ol/format/GeoJSON";
import Select from "ol/interaction/Select";
import VectorSource from "ol/source/Vector";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import { click } from "ol/events/condition";

import Feature from "ol/Feature";
import { getStyle, getClusterStyle } from "../../styles";
import VectorLayer from "ol/layer/Vector";

const geoJSON = new GeoJSON();

export default {
  name: "VectorLayer",
  inject: ["map"],
  created() {
    this.vectorSource = new VectorSource();

    if (this.clusterItems) {
      this.clusterSource = new ClusterSource({
        distance: 25,
        minDistance: 10,
        source: this.vectorSource,
      });

      this.vectorLayer = new AnimatedCluster({
        name: this.name,
        source: this.clusterSource,
        animationDuration: 700,
        style: (feature) => {
          if (feature.get("features").length > 1) {
            return getClusterStyle(feature.get("features").length, false);
          }

          return getStyle(
            this.map,
            this.styleName,
            feature.get("features")[0],
            false
          );
        },
        properties: {
          selectable: this.selectable,
        },
      });

      const selectCluster = new SelectCluster({
        pointRadius: 15,
        animate: false,
        autoClose: true,
        selectCluster: true,
        featureStyle: (f) => {
          var cluster = f.get("features");
          if (cluster && cluster.length > 0) {
            return getStyle(this.map, this.styleName, cluster[0], false);
          }
        },
        style: (f, res) => {
          var cluster = f.get("features");
          if (cluster.length > 1) {
            return getClusterStyle(cluster.length, false);
          }

          return getStyle(this.map, this.styleName, cluster[0], true);
        },
      });

      selectCluster.getFeatures().on(["add"], (e) => {
        const c = e.element.get("features");
        if (c.length === 1) {
          const feature = c[0];
          this.$emit("select", {
            ...feature.getProperties(),
            geometry: geoJSON.writeGeometryObject(feature.getGeometry()),
          });
        }
      });

      const selectInteraction = new Select({
        layers: [this.vectorLayer],
        condition: click,
        style: (feature) => getStyle(this.map, this.styleName, feature, true),
      });

      selectInteraction.on("select", (e) => {
        const features = e.target.getFeatures().getArray();
        if (features.length === 1) {
          const feature = features[0];
          this.$emit("select", {
            ...feature.getProperties(),
            geometry: geoJSON.writeGeometryObject(feature.getGeometry()),
          });
        }
      });

      if (this.clusterItems) {
        this.map.addInteraction(selectCluster);
      }
    } else {
      this.vectorLayer = new VectorLayer({
        name: this.name,
        source: this.vectorSource,
        style: (feature) => {
          return getStyle(this.map, this.styleName, feature, false);
        },
        properties: {
          selectable: this.selectable,
        },
      });
    }

    if (this.features && this.features.length > 0) {
      this.loadFeatures(this.features);
    }

    if (this.url) {
      this.loadUrl(this.url);
    }

    this.map.addLayer(this.vectorLayer);
  },
  unmounted() {
  },
  props: {
    name: String,
    url: String,
    features: Array,
    styleName: String,
    selectable: Boolean,
    clusterItems: Boolean,
  },
  watch: {
    features(features) {
      if (!this.url) {
        this.loadFeatures(features);
      }
    },
  },
  methods: {
    async loadUrl(url) {
      const result = await fetch(url);
      const data = await result.json();
      this.loadFeatures(data.records);
    },
    loadFeatures(features) {
      if (this.vectorSource) {
        this.vectorSource.clear();
      }

      this.vectorSource.addFeatures(
        features.map((feature) => {
          const constructedFeature = new Feature({
            ...feature,
            geometry: geoJSON.readGeometry(feature.geometry),
          });

          constructedFeature.setId(feature.id);

          return constructedFeature;
        })
      );
    },
  },
};
</script>

<style scoped></style>
